import React, { useEffect, useState, useRef } from "react";
import { message, notification } from 'antd';
import { Base64 } from "js-base64";
import dayjs from 'dayjs';
import { DescriptionText, FlexContainer, H1Text, H2Text, Spinner } from "../../design";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import {
    getEventDetailsById,
    // getEventPaymentDetails,
    eventChargeById,
    getHealthCheck,
    getSecretValuesById,
    seatPageSplitUp,
    getServerEncription,
    generateClientKeyPair,
    encryptData,
    getPayPalClientToken,
    getMrn,
    action,
    getWalletOrderInfo,
    confirmWalletOrderInfo,
} from "../../api";
import { PAGES, MESSAGES, SWIREPAY_URL, TabNames, SESSION_TIME, QR_STATUSES, ACQUIRER_TYPE_PAYPAL, ACQUIRER_TYPE_PAYPAL_BNY } from "../../appconstants";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import SmallScreenFooter from "../../components/footer";
import currencyFormatter from "../../utils/currencyformatter";
import CardPayment from "../../components/cardpayment/CardPayment";
import Support from "../../components/support";
import getMenuTabs from "../../utils/getMenuTabs";
import { formatToE164 } from "../../utils/formatToE164";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import UpiPayment from "../../components/upipayment/UpiPayment";
import AchPayment from "../../components/achPaymentWithPlaid";
import InstantPayment from "../../components/instantpayment/InstantPayment";
import GooglePay from "../../components/googlePay/GooglePay";
import BankPayment from "../../components/bankpayment/BankPayment";
import NetBanking from "../../components/netbanking/NetBanking";
import PayPalCheckout from "../paypalCheckout";
import PaymentExpandableRows from "../../components/paymentExpandableRows";
import PaymentExpandableRowsV2 from "../../components/PaymentExpandableRowsV2";
import AlertModal from "../../components/modal/alert";
import RecaptchaModal from "../../components/recaptcha";
import EPaymentImg from "../../assets/imgs/e payments.svg";
import OMEGAITRlogo from "../../assets/imgs/OmegaITRlogo.png";
import UPIIMAGE from "../../assets/imgs/upiNotification.svg";
import { AmountDivideByHundred } from "../../helper";
import Apple from '../../routes/apple';
import { BASE_URLS, getQrPaymentReconnection } from "../../api";
import getRedirectionUrl from "../../utils/getRedirectionUrl";
import { getCountryCallingCode } from "libphonenumber-js";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateStatus } from "../../redux/customerDetailsInfo";
import ApplePayButton from '../../routes/apple/PayPalApplePay';
import PayPalGooglePay from "../../components/payPalGooglePay";
import { setFormData } from "../../redux/appConfigInfo";
import { getCountryCodeAndNumber } from "../../utils/getCountryCodeAndNumber";
import SavedPaymentMethods from "../../components/SavedPaymentMethods";

type Props = {
    history: {
        push: Function,
    },
}

const SeatsPay = (props: Props) => {

    const { match: { params: { eventLinkId } }, location: { pathname, search } } = props;
    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [payment, setPayment] = useState(null);
    const [errorMessage, setErrorMessage] = useState();
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [backButtonUrl, setBackButtonUrl] = useState(SWIREPAY_URL);
    const [submitBtnText, setSubmitBtnText] = useState(null);
    const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
    const [paymentTypeOrder, setPaymentTypeOrder] = useState(null);
    const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${eventLinkId}-tap-index`) || 0));
    const [tabName, setTabName] = useState('');
    const [banksList, setBanksList] = useState(null);
    const [isTest, setIsTest] = useState(null);
    const [bankTypes, supportedBankTypes] = useState([null]);
    const [bankImageUrl, setBankImageUrl] = useState(null);
    const [partnerImageUrl, setPartnerImageUrl] = useState(null);
    const [gpaySecretValues, setGpaySecretValues] = useState(null);
    const [gpayError, setGpayError] = useState(null);
    const [processStatus, setProcessStatus] = useState(false);
    const [eventDetails, setEventDetails] = useState();
    const [selectedSeats, setSelectedSeats] = useState([]);
    const selectedData = localStorage.getItem('seatsData');
    const [amountInfo, setAmountInfo] = useState();
    const [selectedEntries, setSelectedEntries] = useState();
    const [nonEventSeat, setNonEventSeat] = useState(false);
    const [upiDownTime, setUpiDownTime] = useState(false);
    const [customerInfo, setCustomerInfo] = useState({});
    const [accountInfo, setAccountInfo] = useState();
    const [applePayment, setApplePayment] = useState(false);
    const [isApplePay, setIsApplePay] = useState(false);
    const [swirepayUS, setSwirepayUS] = useState(false);
    const [googlePayUs, setGooglePayUs] = useState(false);
    const hostName = (window && window.location && window.location.host);
    const [redirectUrl, setRedirectUrl] = useState('');
    const [net, setNet] = useState(null);
    const [feeService, setFeeService] = useState(null);
    const [finalTax, setFinalTax] = useState(null);
    const [totalPayable, setTotalPayable] = useState(null);
    const [totalPayableAch, setTotalPayableAch] = useState(null);
    const [caluclation, setCaluclation] = useState(null);
    const [discount, setDiscount] = useState(null);
    const [loading, setLoading] = useState(false);
    const [finalTip, setFinalTip] = useState(null);
    const [subTotal, setSubTotal] = useState(null);
    const [serviceFeeVal, setServiceFeeVal] = useState(null);
    const [serviceFeeRateVal, setServiceFeeRateVal] = useState(null);
    const [finalAmount, SetFinalAmount] = useState(null);
    const [taxValue, setTaxValue] = useState(null);
    const [taxPercentage, setTaxPercentage] = useState(null);
    const [surcharge, setSurcharge] = useState(null);
    const [serviceFeeRate, setServiceFeeRate] = useState(false);
    const [serviceFee, setServiceFee] = useState(false);
    const [updatedCardNum, setUpdatedCardNum] = useState('');
    const [optionalCheck, setOptionalCheck] = useState(true);
    const [recaptchaModalVisible, setRecaptchaModalVisible] = useState(false);
    const [savedPaymentDetails, setSavedPaymentDetails] = useState(null);
    const [recaptchaPaymentType, setRecaptchaPaymentType] = useState(null);
    const [paymentLinkUpiGlobalRecaptcha, setPaymentLinkUpiGlobalRecaptcha] = useState(null);
    const [paymentLinkInstantPaymentGlobalRecaptcha, setPaymentLinkInstantPaymentGlobalRecaptcha] = useState(null);
    const accountGid = [
        'account-cdfe7eecff324778a88a2727177a1c8f'
    ];
    const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${eventLinkId}`) || undefined);
    const [manualPlaidPayment, setManualPlaidPayment] = useState(false);
    const updateCustomerRedux = useSelector((state) => state.customerDetailsInfo);
    const dispatch = useDispatch();
    const [payPalClientAuth, setPayPalClientAuth] = useState('');
    const [paypalApplePayMessageModal, setPaypalApplePayMessageModal] = useState(false);
    const isPayPalApple = useRef(false);
    const isPayPalGoogle = useRef(false);
    const [paypalApplePayRecaptcha, setPaypalApplePayRecaptcha] = useState(null);
    const [cardPointGooglePayToken, setCardPointGooglePayToken] = useState(null);
    const paypalPaymentData = useRef(null);
    const [payPalClientId, setPaypalClientId] = useState('');
    const commonRecaptchaToken = useRef(null);
    const [orderDatas, setOrderData] = useState();

    let seatsData = [];
    let totalAmount = 0;
    let testObject = {};
    let finalSeatsData = [];

    const defaultAlertConfig = {
        showIcon: false, isOpen: false, hideBtn: true,
        cancel: null, header: null, body: null,
        submitBtnText: null, cancelBtnText: null, showCancelBtn: false,
        showSubmitBtn: false, submit: null, icon: null
    };

    const [alertConfig, setAlertConfig] = useState(defaultAlertConfig);

    const getPayPalAccountInfo = async (id) => {
        try {
            const payPalInfo = await getPayPalClientToken(id);
            const value = Base64.decode(payPalInfo);
            const value_json = JSON.parse(value);
            setPaypalClientId(value_json?.clientId);
            setPayPalClientAuth(payPalInfo);
            return payPalInfo;
        } catch (e) {
            console.error(e);
        }
        return null;
    }

    useEffect(() => {
        const acquirer = payment?.account?.acquirer;
        if (payment?.account?.gid && (acquirer === ACQUIRER_TYPE_PAYPAL || acquirer === ACQUIRER_TYPE_PAYPAL_BNY)) {
            getPayPalAccountInfo(payment?.account?.gid);
        }
    }, [payment]);

    useEffect(() => {
        if (search) {
            getEventDataWithSearchValue()
        } else {
            getEventDataWithoutSearchValue();
        }
        localStorage.setItem('checkoutPage', true);

    }, [eventLinkId, search]);

    useState(() => {
        if (window.ApplePaySession) {
            setIsApplePay(true);
        }
    }, []);

    useEffect(() => {
        if(updateCustomerRedux?.updateStatus && updateCustomerRedux?.customerDetails){
            if (updateCustomerRedux?.customerDetails?.name  && updateCustomerRedux?.customerDetails?.name !== '') {
                if (eventDetails?.name) {
                setEventDetails((prev) => ({...prev, name: updateCustomerRedux.customerDetails.name }));
                } else {
                setCustomerInfo((prev) => ({...prev, name: updateCustomerRedux.customerDetails.name }));
                };
            };
            if (updateCustomerRedux?.customerDetails?.email  && updateCustomerRedux?.customerDetails?.email !== '') {
                if (eventDetails?.email) {
                setEventDetails((prev) => ({...prev, email: updateCustomerRedux.customerDetails.email }));
                } else {
                setCustomerInfo((prev) => ({...prev, email: updateCustomerRedux.customerDetails.email }));
                };
            };
            if (updateCustomerRedux?.customerDetails?.phoneNumber && updateCustomerRedux?.customerDetails?.phoneNumber !== 'undefined'
                && updateCustomerRedux?.customerDetails?.phoneNumber !== '+1') {
                if (eventDetails?.phoneNumber) {
                setEventDetails((prev) => ({...prev, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber }));
                } else {
                setCustomerInfo((prev) => ({...prev, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber }));
                };
            };
            dispatch(setUpdateStatus(false));
        }
    }, [updateCustomerRedux]);

    useEffect(() => {
        setApplePayment(payment && payment.account && payment.account.supportedPaymentTypes.includes('APPLE_PAY_US'));
        setSwirepayUS(payment && payment.account && payment.account.supportedPaymentTypes.includes('SWIREPAY_US'));
        setGooglePayUs(payment && payment.account && payment.account.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
        getSplitUp(payment?.seatPageMeta?.gid);
        if (selectedData) {
            seatsData = JSON.parse(selectedData);
            setSelectedSeats(seatsData);
            let seatedFlag = false;
            const tempObject = {};
            for (let i = 0; i < seatsData.length; i += 1) {
                if (seatsData[i].type === 'PRICE_AMOUNT_STOCK_BASED') {
                    setNonEventSeat(true);
                    seatedFlag = true;
                }
                if (seatsData[i].type === 'INPUT_EMAIL') {
                    tempObject.email = seatsData[i].value;
                }
                if (seatsData[i].type === 'INPUT_PHONE') {
                    tempObject.phoneNumber = seatsData[i].value;
                }
                if (seatsData[i].type === 'INPUT_SINGLE_LINE_TEXT') {
                    tempObject.name = seatsData[i].value;
                }
                if (seatsData[i].type === 'PROMOTIONAL_CODES') {
                    tempObject.promotionalCode = seatsData[i].value;
                }
            }
            setCustomerInfo(tempObject);
            if (!seatedFlag) {
                for (let i = 0; i < seatsData.length; i += 1) {
                    if (seatsData[i].type === 'PROMOTIONAL_CODES') {
                        finalSeatsData.push(seatsData[i]);
                    } else {
                        testObject.seatPageMetaTicketGid = seatsData[i].selectedTicketType;
                        if (eventDetails) {
                            const seatPageMetaTicket = eventDetails.seatPageMetaTickets.filter((data) => data.gid === seatsData[i].selectedTicketType)
                            testObject.label = seatPageMetaTicket[0].name;
                            testObject.category = seatPageMetaTicket[0].category;
                        } else {
                            testObject.label = seatsData[i].label;
                            testObject.category = seatsData[i].category.label;
                        }
                        testObject.value = seatsData[i].seatPrice * 100;
                        testObject.seat = seatsData[i].seatId;
                        finalSeatsData.push(testObject);
                        testObject = {};
                    }
                }
            } else if (seatedFlag) {
                finalSeatsData = seatsData;
            }

            setSelectedEntries(finalSeatsData);
        }
    }, [selectedData, eventDetails]);

    useEffect(() => {
        if (amountInfo && eventDetails && eventDetails.seatPageMetaTickets[0]) {
            payment.amount = amountInfo?.totalPayable;
            setServiceFeeRateVal((AmountDivideByHundred(totalAmount) * AmountDivideByHundred(serviceFeeRate)) / 100);
            setServiceFeeVal(AmountDivideByHundred(serviceFee));
            SetFinalAmount(`${payment.amount?.currency?.prefix} ${totalPayable || 0}`)
            setSubmitBtnText(`PAY ${currencyFormatter((amountInfo && (amountInfo.totalPayable / 100.0)), eventDetails && eventDetails.seatPageMetaTickets[0].currency.name)}`)
        }
    }, [eventDetails, amountInfo]);

    useEffect(() => {
        setErrorMessage(null);
    }, [selectedTab]);



    const chargeByApple = async (paymentData, recaptchaToken = null) => {
      const {
        deviceData,
        // amount,
        customerName,
        customerEmail,
        customerPhone,
        countryCode,
        stateCode,
        street,
        postalCode,
        city,
        cardNetwork,
        cardType,
        cardLast4,
      } = paymentData;
      setRecaptchaPaymentType('paypalApplePay');
      const billingAddress = {
          city: city,
          countryCode: countryCode,
          state: stateCode,
          street: street
        };
      const paymentMethod = {
        applePayUS: {
          deviceData: deviceData,
          cardBrand: cardNetwork,
          cardFundingType: cardType,
          applePayDynamicLast4: cardLast4,
          cardLast4: cardLast4
        },
        type: "WALLET",
        subType: "APPLE_PAY_US",
        postalCode: postalCode,
        paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
      }
      let customer = {
        email: customerEmail,
        name: customerName,
        phoneNumber: customerPhone
      }

      if (paymentData?.token?.paymentMethod?.type === 'credit') {
            paymentMethod.applePayUS.binType = 'CREDIT';
        }

        if (paymentData?.paymentMethod?.type === 'credit') {
            paymentMethod.applePayUS.binType = 'CREDIT';
        }

        if (paymentData?.cardType === 'credit') {
            paymentMethod.applePayUS.binType = 'CREDIT';
        }

      if (!nonEventSeat) {
        const meta = eventDetails.seatPageMetaTickets;
        const categ = meta.filter((item) => item.type !== 'TICKET');
        for (let i = 0; i < categ.length; i += 1) {
          const tempObj = {};
          tempObj.seatPageMetaTicketGid = categ[i].gid;
          tempObj.type = categ[i].type;
          // tempObj.value = data[categ[i].type];
          tempObj.value = categ[i].value;
          selectedEntries.push(tempObj);
        }
      }
      const dataSelected = JSON.parse(selectedData);

      const promocode = dataSelected.filter((item) => item.type === 'PROMOTIONAL_CODES');

      if (promocode && promocode.length > 0) {
        for (let i = 0; i < promocode.length; i += 1) {
          for (let j = 0; j < selectedEntries.length; j += 1) {
            if (promocode[i].seatPageMetaTicketGid === selectedEntries[j].seatPageMetaTicketGid) {
              selectedEntries[j].value = promocode[i].value;
            }
          }
        }
      }
      const value = await getPayPalAccountInfo(payment?.account?.gid);
      if (value) {
          isPayPalApple.current = true;
      }
      const responseEntity = await chargeById({
        seatPageMetaGid: eventDetails.gid,
        customerGid: getCustomerGidFromPayment(payment),
        customerDetails: customer,
        paymentMethodDetails: paymentMethod,
        seatPageTicketEntries: selectedEntries,
        paymentMethodType: [
          'WALLET'
        ],
      }, recaptchaToken);
      isPayPalApple.current = false;
      return responseEntity;
    }

    const chargeByCardpointeApplePay = async (paymentData) => {
        const {
            deviceData,
            // amount,
            customerName,
            customerEmail,
            customerPhone,
            countryCode,
            stateCode,
            street,
            postalCode,
            city,
            cardNetwork,
            cardType,
            cardLast4,
        } = paymentData;
        
        const billingAddress = {
            city: city,
            countryCode: countryCode,
            state: stateCode,
            street: street
        };

        const paymentMethod = {
            applePayUS: {
                deviceData: deviceData,
                cardBrand: cardNetwork,
                cardFundingType: cardType,
                applePayDynamicLast4: cardLast4,
                cardLast4: cardLast4
            },
            type: "WALLET",
            subType: "APPLE_PAY_US",
            postalCode: postalCode,
            paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
        }

        let customer = {
            email: customerEmail,
            name: customerName,
            phoneNumber: customerPhone,
        }

        if (!nonEventSeat) {
            const meta = eventDetails.seatPageMetaTickets;
            const categ = meta.filter((item) => item.type !== 'TICKET');
            for (let i = 0; i < categ.length; i += 1) {
                    const tempObj = {};
                    tempObj.seatPageMetaTicketGid = categ[i].gid;
                    tempObj.type = categ[i].type;
                    // tempObj.value = data[categ[i].type];
                    tempObj.value = categ[i].value;
                    selectedEntries.push(tempObj);
                }
        }

        const dataSelected = JSON.parse(selectedData);

        const promocode = dataSelected.filter((item) => item.type === 'PROMOTIONAL_CODES');

        if (promocode && promocode.length > 0) {
            for (let i = 0; i < promocode.length; i += 1) {
            for (let j = 0; j < selectedEntries.length; j += 1) {
                if (promocode[i].seatPageMetaTicketGid === selectedEntries[j].seatPageMetaTicketGid) {
                selectedEntries[j].value = promocode[i].value;
                }
            }
            }
        }

        if (paymentData?.token?.paymentMethod?.type === 'credit') {
            paymentMethod.applePayUS.binType = 'CREDIT';
        }

        if (paymentData?.paymentMethod?.type === 'credit') {
            paymentMethod.applePayUS.binType = 'CREDIT';
        }

        if (paymentData?.cardType === 'credit') {
            paymentMethod.applePayUS.binType = 'CREDIT';
        }

        await chargeById({
            seatPageMetaGid: eventDetails.gid,
            customerGid: getCustomerGidFromPayment(payment),
            customerDetails: customer,
            paymentMethodDetails: paymentMethod,
            seatPageTicketEntries: selectedEntries,
            paymentMethodType: [
                'WALLET'
            ],
        }, null);
    };


    // const getPaymentInfo = async (list, data) => {
    //     setShowSpinner(true);
    //     try {
    //         const value = await getEventPaymentDetails(list, data.gid);
    //         if (value) {
    //             setAmountInfo(value)
    //         }
    //     } catch (e) {
    //         // props.history.push(`${pathname}/error`);
    //         console.log(e);
    //     } finally {
    //         setShowSpinner(false)
    //     }
    // };

    const getEventDataWithSearchValue = async () => {
        const params = new URLSearchParams(search);
        if (!(params.get('ps') || params.get('mp')) || !params.get('secret')) {
            props.history.push(`${pathname}/error`);
            return;
        }
        setShowSpinner(true);
        try {
            const value = await getEventDetailsById(eventLinkId, search);
            if (value) {
                const { redirectUri } = value;
                const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                setTransactionSuccessModalOpen(true);
                setTimeout(function () {
                    localStorage.removeItem("seatsData");
                    props.history.push(`${PAGES.SEATSPAGE_PAY}/${eventLinkId}`);
                }, timeOut);
            }
        } catch (reason) {
            try {
                const value = await getEventDetailsById(eventLinkId, null);
                if (value) {
                     dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
                      value: {
                        phoneNumber: value.seatPageMeta?.phoneNumber ? getCountryCodeAndNumber(value.seatPageMeta?.phoneNumber)?.phoneNumber : '',
                        countryCode: value.seatPageMeta?.phoneNumber ? getCountryCodeAndNumber(value.seatPageMetar?.phoneNumber)?.countryCode : '+1',
                        name: value.seatPageMeta?.name,
                        email: value.seatPageMeta?.email,
                      } 
                    }));
                    setEventDetails(value.seatPageMeta)
                    setAccountInfo(value.account);
                    value.currency = value?.account?.currency;
                    value.amount = amountInfo?.totalPayable;
                    setPayment(value);
                    setRedirectUrl(value?.seatPageMeta?.redirectUrl);
                    // getPaymentInfo(finalSeatsData, value.seatPageMeta);
                }
            } catch (e) {
                props.history.push(`${pathname}/error`);
            }
        } finally {
            setShowSpinner(false);
        }
    };

    const error = reason => {
        setErrorMessage(null);
        if (!reason) return;
        const { data: { message, messageCode }, status } = reason;
        if (MESSAGES.PAYMENT_LINK.EXPIRED === message) {
            props.history.push(`${pathname}/expired`)
        } else {
            if (messageCode === 5102) {
                props.history.push(`${pathname}/error`);
                return;
            }
            setErrorMessage(message);
            if (status === 500) {
                setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
            }
            resetAlertConfig();
            setTransactionModalOpen(false);
            const errorEl = document.getElementById("error");
            if (null !== errorEl) { errorEl.scrollIntoView(); }
        }
    };

    const getGooglePayMerchantValues = async (accountGid) => {
        try {
            const values = await getSecretValuesById(accountGid, null);
            setGpaySecretValues(values);
        } catch (error) {
            setGpayError('Missing merchant details. Please contact support')
        }
    };


    const updateSurcharge = (val, selectedDirectoryGid = null) => {
        getSplitUp(payment?.seatPageMeta?.gid, localStorage.getItem(`${eventLinkId}-tab-name`) ? localStorage.getItem(`${eventLinkId}-tab-name`) : 0, updatedCardNum, val, selectedDirectoryGid);
    }

    const getCurrentTab = (tabName) => {
        getSplitUp(payment?.seatPageMeta?.gid, tabName, '');
    };

    const getCardNum = (cardNum) => {
        setUpdatedCardNum(cardNum);
        getSplitUp(payment?.seatPageMeta?.gid, localStorage.getItem(`${eventLinkId}-tab-name`) ? localStorage.getItem(`${eventLinkId}-tab-name`) : 0, cardNum);
    };

    const getSplitUp = async (metaGid, tabName, cardNum, val, selectedDirectoryGid = null) => {
        if (!selectedEntries) {
            return;
        }
        const payload = {
            seatPageTicketEntries: selectedEntries,
            paymentType: (tabName === 'DIRECTORY' && selectedDirectoryGid) ? 'DIRECTORY' : (tabName !== 'CARD' && !cardNum) ? tabName || '' : (cardNum ? 'CARD' : ''),
            cardNumber: tabName === 'CARD' ? cardNum : null,
            surchargeApplicable: (payment?.seatPageMeta?.surchargeEnabled && payment?.account?.surchargeType && payment?.account?.surchargeType !== 'NONE') ? true : false,
            directoryPaymentMethodGid: tabName === 'DIRECTORY' ? selectedDirectoryGid : null,
        }
        if (val === true || val === false) {
            setOptionalCheck(val)
            payload.surchargeApplicable = val;
        }
        try {
            const value = await seatPageSplitUp(metaGid, payload);
            setAmountInfo(value)
            // setNet(value.net);
            // setFeeService(value.serviceFee);
            // setFinalTax(value.tax);
            // setTotalPayable(value.totalPayable);
            // setCaluclation(value);
            // setFinalTip(value.tip);
            // setDiscount(value.discountedAmount);
            // setSubTotal(value.subTotal);
            setSurcharge(value.surcharge);
        } catch (reason) {
            error(reason);
        }
    }

    const getEventDataWithoutSearchValue = async () => {
        setShowSpinner(true);
        try {
            const value = await getEventDetailsById(eventLinkId, null);
            value.currency = value?.account?.currency;
            value.amount = amountInfo?.totalPayable;
            setPayment(value);
            setRedirectUrl(value?.seatPageMeta?.redirectUrl);
            getSplitUp(value?.seatPageMeta?.gid);
            // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
            //     const val = await getHealthCheck();
            //     if (val && val.status !== 'ACTIVE') {
            //         setUpiDownTime(true);
            //         notification.open({
            //             message: '',
            //             description: <img src={UPIIMAGE} alt="" />,
            //           });
            //     }
            //   }
            if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('GOOGLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && !swirepayUS && value.account.supportedPaymentTypes).includes('WALLET')) {
                getGooglePayMerchantValues(value && value.account && value.account.gid);
            }
            if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('APPLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && !swirepayUS && value.account.supportedPaymentTypes).includes('WALLET')) {
                getGooglePayMerchantValues(value && value.account && value.account.gid);
            }
            if (value && value.seatPageMeta) {
                setEventDetails(value.seatPageMeta);
                setAccountInfo(value.account);
            }
            if (value.account.paymentTypeOrder) {
                const paymentMethod = getUniquePaymentTypes(value.account && value.account.supportedPaymentTypes);
                const paymentOrders = value && value.account && value.account.paymentTypeOrder;
                const filterPaymentOrder = paymentOrders.filter((order) => paymentMethod.includes(order.category));
                const wallet = paymentOrders.filter((item) => item.category === 'WALLET');
                let newfilterPaymentOrder;
                if (value.account && paymentMethod.includes('WALLET')) {
                    setPaymentTypeOrder(filterPaymentOrder);
                } if (value.account
                    && (value.account.supportedPaymentTypes.includes('GOOGLE_PAY_US') || value.account.supportedPaymentTypes.includes('SWIREPAY_US'))
                    && wallet && wallet.length > 0) {
                    const googlePay = {
                        order: 4,
                        category: "WALLET",
                    }
                    filterPaymentOrder.push(googlePay);
                    setPaymentTypeOrder(filterPaymentOrder);
                    setPaymentTypeOrder(filterPaymentOrder);
                } else {
                    newfilterPaymentOrder = filterPaymentOrder.filter(info => info.category !== 'WALLET');
                    setPaymentTypeOrder(newfilterPaymentOrder);
                }
            } else {
                setSupportedPaymentTypes(value.account && value.account.supportedPaymentTypes);
            }
            // getPaymentInfo(finalSeatsData, value.seatPageMeta);
        } catch (e) {
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    const getCustomerGidFromPayment = () => {
        return payment && payment.customer && payment.customer.gid;
    };

    const chargeByUpi = async (data) => {
        const { customer, paymentMethod, notify } = data;
        await chargeById({ customer, paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByAch = async (data) => {
        const { customer, paymentMethod } = data;
        await chargeById({
            seatPageMetaGid: eventDetails.gid,
            customerGid: getCustomerGidFromPayment(payment),
            customerDetails: customer,
            paymentMethodDetails: paymentMethod,
            seatPageTicketEntries: selectedEntries,
            paymentMethodType: [
                'ACH_LEGACY'
            ],
        });
        // await chargeById({ customer, paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

  const chargeBySavedPaymentMethods = async (data) => {
    await chargeById({
        paymentMethodDetails: data,
        seatPageTicketEntries: selectedEntries,
        seatPageMetaGid: eventDetails.gid,
        customerDetails: {
            name: updateCustomerRedux?.customerDetails?.name,
            email: updateCustomerRedux?.customerDetails?.email,
            phoneNumber: updateCustomerRedux?.customerDetails?.phoneNumber,
        }
    });
  };

    const getByLabelText = (type) => {
        if (type === 'INPUT_ALPHA_NUMERIC') {
            return 'Alpha Numeric';
        } if (type === 'INPUT_NUMBER') {
            return 'Number';
        } if (type === 'INPUT_SINGLE_LINE_TEXT') {
            return 'Single Line Text';
        }
        return null;
    };

    const getQrPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
            const value = await getQrPaymentReconnection(paymentSession, psClientSecret);
            if (value) {
                const { status, receiptNumber } = value;
                const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (status === QR_STATUSES.SUCCEEDED) {
                    if (!redirectionUri) {
                        setTransactionSuccessModalOpen(true);
                    }
                    setTimeout(function () {
                        const redirectUrl = redirectionUri ? redirectionUri : '';
                        const urlPath = redirectUrl.includes("?");
                        if (urlPath) {
                            window.location = `${redirectUrl}&seat-page-link=${eventLinkId}`;
                        } else if (redirectUrl && !urlPath) {
                            window.location = `${redirectUrl}?seat-page-link=${eventLinkId}`;
                        } else {
                            props.history.push(`${PAGES.SEATSPAGE_PAY}/${eventLinkId}`);
                        }
                    }, timeOut);
                    if (eventLinkId) { localStorage.removeItem(`${eventLinkId}-tap-index`); localStorage.removeItem(`${eventLinkId}-tab-name`) }
                }
            }
        } catch (reason) {
            error(reason);
        }
    };

    const chargeByCard = async (data) => {
        const { customer, paymentMethod, promoter } = data;
        if (!nonEventSeat) {
            const meta = eventDetails.seatPageMetaTickets;
            const categ = meta.filter((item) => item.type !== 'TICKET');
            for (let i = 0; i < categ.length; i += 1) {
                const tempObj = {};
                tempObj.seatPageMetaTicketGid = categ[i].gid;
                tempObj.type = categ[i].type;
                tempObj.value = data[categ[i].type];
                selectedEntries.push(tempObj);
            }
        }

        const dataSelected = JSON.parse(selectedData);

        const promocode = dataSelected.filter((item) => item.type === 'PROMOTIONAL_CODES');

        if (promocode && promocode.length > 0) {
            for (let i = 0; i < promocode.length; i += 1) {
                for (let j = 0; j < selectedEntries.length; j += 1) {
                    if (promocode[i].seatPageMetaTicketGid === selectedEntries[j].seatPageMetaTicketGid) {
                        selectedEntries[j].value = promocode[i].value;
                    }
                }
            }
        }
        const payload = {
            seatPageMetaGid: eventDetails.gid,
            customerDetails: customer,
            paymentMethodDetails: paymentMethod,
            seatPageTicketEntries: selectedEntries,
            acceptPromotion: promoter === undefined ? true : promoter,
            paymentMethodType: [
                'CARD'
            ],
        };
        await chargeById(payload);
    };

    const chargeByBank = async (data) => {
        const { fundingSourceId } = data;
        const paymentMethod = {
            type: "ACH",
            bank: {
                referenceId: fundingSourceId,
            },
        };
        await chargeById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByNetBanking = async (data) => {
        const { gid, notify } = data;
        const paymentMethod = {
            type: "NET_BANKING",
            netbanking: {
                swirepayBankGid: gid,
            },
        };
        await chargeById({ paymentMethod: paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByInstantPay = async (data) => {
        const { walletAlias, notify } = data;
        const paymentMethod = {
            type: "INSTANT_PAYMENT",
            instantPayment: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        await chargeById({ paymentMethod: paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeBySwirepayUS = async (data) => {
        const { walletAlias, promoter } = data;
        const paymentMethod = {
            type: "WALLET",
            subType: "SWIREPAY_US",
            swirepayUS: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };

        if (!nonEventSeat) {
            const meta = eventDetails.seatPageMetaTickets;
            const categ = meta.filter((item) => item.type !== 'TICKET');
            for (let i = 0; i < categ.length; i += 1) {
                const tempObj = {};
                tempObj.seatPageMetaTicketGid = categ[i].gid;
                tempObj.type = categ[i].type;
                tempObj.value = data[categ[i].type];
                selectedEntries.push(tempObj);
            }
        }

        const dataSelected = JSON.parse(selectedData);

        const promocode = dataSelected.filter((item) => item.type === 'PROMOTIONAL_CODES');

        if (promocode && promocode.length > 0) {
            for (let i = 0; i < promocode.length; i += 1) {
                for (let j = 0; j < selectedEntries.length; j += 1) {
                    if (promocode[i].seatPageMetaTicketGid === selectedEntries[j].seatPageMetaTicketGid) {
                        selectedEntries[j].value = promocode[i].value;
                    }
                }
            }
        }

        const payload = {
            seatPageMetaGid: eventDetails.gid,
            paymentMethodDetails: paymentMethod,
            seatPageTicketEntries: selectedEntries,
            acceptPromotion: promoter === undefined ? true : promoter,
            paymentMethodType: [
                'WALLET'
            ],
        };
        await chargeById(payload);
    };

    const chargeByIdSuccessActions = async (value) => {
        const { nextActionUrl, redirectUri, paymentStatus } = value;
        if (paymentStatus && paymentStatus === 'PROCESSING') {
            setProcessStatus(true);
        }
        if (paymentStatus && paymentStatus === 'REQUIRE_CONFIRMATION') {
            setManualPlaidPayment(true);
        }
        if (nextActionUrl) {
            window.location = nextActionUrl;
            return;
        }
        const timeOut = value?.paymentStatus ? SESSION_TIME.MANUAL_PLAID : 5000;
        setTransactionModalOpen(false);
        setTransactionSuccessModalOpen(true);
        localStorage.removeItem("seatsData");
        if (redirectUrl) {
            setTimeout(function () {
                window.location = redirectUrl;
                return;
            }, timeOut);
        } else if (redirectUri && !redirectUrl) {
            setTimeout(function () {
                window.location = redirectUri;
                return;
            }, timeOut);
        } else {
            setTimeout(function () {
                props.history.push(`${PAGES.SEATSPAGE_PAY}/${eventLinkId}`);
            }, timeOut);
        }
    };

    const chargeById = async (data, recaptchaToken = null) => {
        data.surchargeApplicable = (payment?.account?.surchargeType === 'OPTIONAL' && payment?.seatPageMeta?.surchargeEnabled) ? optionalCheck : (payment?.seatPageMeta?.surchargeEnabled && payment?.account?.surchargeType !== 'NONE') ? true : false;
        setTransactionModalOpen(true);
        try {
            const values = await getServerEncription(recaptchaToken);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    }
                    if (encriptedData?.keyId) {
                        const value = await eventChargeById(eventLinkId, payload);
                        if (!isPayPalApple.current
                            && !isPayPalGoogle.current
                        ) {
                            await chargeByIdSuccessActions(value);
                        }
                        return value;
                    }
                }
            }
        } catch (reason) {
            if (reason?.status === 429){
                setSavedPaymentDetails(data);
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                return;
            }
            error(reason);
            return reason;
        }
    };

    const onGlobalCaptchaVerified = async (token) => {
        setRecaptchaModalVisible(false);
        switch (recaptchaPaymentType) {
            case TabNames.UPI:
                setPaymentLinkUpiGlobalRecaptcha(token);
                break;
            case TabNames.INSTANT_PAYMENT:
                setPaymentLinkInstantPaymentGlobalRecaptcha(token);
                break;
            case 'paypalApplePay':
                setPaypalApplePayRecaptcha(token);
                setPaypalApplePayMessageModal(true);
                break;
            case 'paypalGooglePay':
                if (paypalPaymentData.current) {
                    chargeByPaypalGooglePay(paypalPaymentData.current, token);
                }
                break;
            case 'cardPointGooglePay':
                setCardPointGooglePayToken(token);
                break;
            case 'payPalButton':
                commonRecaptchaToken.current = token;
                break;
            default:
                await chargeById(savedPaymentDetails, token);
        }
        setRecaptchaPaymentType(null);
    }

    const resetAlertConfig = () => {
        setAlertConfig(defaultAlertConfig)
    };

    const chargeByIdFailActions = async () => {
        setTransactionModalOpen(false);
    };

    const chargeByPaypalGooglePay = async (data, localRecaptchaToken = null) => {
        const formattedPhoneNumber = formatToE164(
            data?.paymentMethodData?.info?.billingAddress?.phoneNumber,
            data?.paymentMethodData?.info?.billingAddress?.countryCode,
            '+14485555555',
        );

        let customerDetails = {
            email: data?.email ?? 'anonymous@swirepay.com',
            phoneNumber: formattedPhoneNumber,
            name: data?.shippingAddress?.name ?? data?.paymentMethodData?.info?.billingAddress?.name ?? 'anonymous user',
        }
        try {
            paypalPaymentData.current = data;
            setTransactionModalOpen(true);
            setRecaptchaPaymentType('paypalGooglePay');
            const value = await getPayPalAccountInfo(payment?.account?.gid);
            if (value) {
                isPayPalGoogle.current = true;
                const paymentMethod = {
                    type: "WALLET",
                    subType: "GOOGLE_PAY_US",
                    googlePayUS: {
                        apiVersionMinor: data.apiVersionMinor,
                        apiVersion: data.apiVersion,
                        paymentMethodDescription: data.paymentMethodData.description,
                        paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                        paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                        paymentMethodType: data.paymentMethodData.type,
                        paymentMethodInfo: data.paymentMethodData.info
                    },
                };
                if (data?.paymentMethodData?.info?.cardFundingSource === 'CREDIT') {
                    paymentMethod.googlePayUS.binType = 'CREDIT';
                }
                const responseEntity = await chargeById({
                    seatPageMetaGid: eventDetails.gid,
                    paymentMethodDetails: paymentMethod,
                    seatPageTicketEntries: selectedEntries,
                    // acceptPromotion: data.promoter === undefined ? true : data.promoter,
                    customerDetails: customerDetails,
                    paymentMethodType: [
                        'WALLET'
                    ],
                }, localRecaptchaToken);
                isPayPalGoogle.current = false;
                const orderId = await getMrn(responseEntity.paymentSessionGid, responseEntity.psClientSecret);
                // Step 2: confirm PayPal order
                await window.paypal.Googlepay().confirmOrder({
                    orderId,
                    paymentMethodData: data?.paymentMethodData,
                });
                // Step 3: capture/perform final action
                await action(responseEntity.paymentSessionGid, responseEntity.psClientSecret);
                await chargeByIdSuccessActions(responseEntity);
            }
        } catch (err) {
            console.error('Google Pay Failed', err);
            message.error('GooglePay Transaction Failed');
            chargeByIdFailActions();
        } finally {
            setTransactionModalOpen(false);
        }
    };

    const chargeByGooglePay = async (data) => {
        const formattedPhoneNumber = formatToE164(
            data?.paymentMethodData?.info?.billingAddress?.phoneNumber,
            data?.paymentMethodData?.info?.billingAddress?.countryCode
        );

        let customerDetails = {
            email: data?.email || "",
            phoneNumber: formattedPhoneNumber,
            name: data?.shippingAddress?.name || "",
        }
        const paymentMethod = {
            type: "WALLET",
            subType: "GOOGLE_PAY_US",
            googlePayUS: {
                apiVersionMinor: data.apiVersionMinor,
                apiVersion: data.apiVersion,
                paymentMethodDescription: data.paymentMethodData.description,
                paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                paymentMethodType: data.paymentMethodData.type,
                paymentMethodInfo: data.paymentMethodData.info
            },
        };
        if (data?.paymentMethodData?.info?.cardFundingSource === 'CREDIT') {
          paymentMethod.googlePayUS.binType = 'CREDIT';
        }
        setRecaptchaPaymentType('cardPointGooglePay');
        await chargeById({
            seatPageMetaGid: eventDetails.gid,
            paymentMethodDetails: paymentMethod,
            seatPageTicketEntries: selectedEntries,
            // acceptPromotion: data.promoter === undefined ? true : data.promoter,
            customerDetails: customerDetails,
            paymentMethodType: [
                'WALLET'
            ],
        }, cardPointGooglePayToken);
    };

    const onApprove = async (data) => {
        try {
            await confirmWalletOrderInfo(orderDatas?.paymentSessionGid, orderDatas?.psClientSecret);
            setTransactionSuccessModalOpen(true);
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    const createOrder = async (paypalData, actions) => {
        try {
            const values = await getServerEncription(commonRecaptchaToken?.current ?? null);
            if (values?.public_key) {
                const keys = generateClientKeyPair();
                if (keys?.privateKey) {
                    let data = {};
                    let customer = {
                        name: updateCustomerRedux?.customerDetails?.name,
                        email: updateCustomerRedux?.customerDetails?.email,
                        phoneNumber: updateCustomerRedux?.customerDetails?.phoneNumber,
                    };
                    if (paypalData?.paymentSource === 'paypal') {
                        data = {
                            seatPageMetaGid: eventDetails.gid,
                            customerDetails: customer,
                            seatPageTicketEntries: selectedEntries,
                            paymentMethodDetails: {
                                payPalWallet: {
                                    rawData: {
                                        experience_context: {
                                            payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                                            landing_page: "LOGIN",
                                            return_url: SWIREPAY_URL,
                                            cancel_url: SWIREPAY_URL,
                                        }
                                    }
                                },
                                type: "WALLET",
                                subType: "PAYPAL_WALLET"
                            }
                        }
                    } else if (paypalData?.paymentSource === 'venmo') {
                        data = {
                            seatPageMetaGid: eventDetails.gid,
                            customerDetails: customer,
                            seatPageTicketEntries: selectedEntries,
                            paymentMethodDetails: {
                                venmo: {
                                    rawData: {
                                        experience_context: {
                                            payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                                            landing_page: "LOGIN",
                                            return_url: SWIREPAY_URL,
                                            cancel_url: SWIREPAY_URL,
                                        }
                                    }
                                },
                                type: "WALLET",
                                subType: "VENMO"
                            }
                        }
                    }
                    const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
                    const payload = {
                        publicKey: keys?.publicKey,
                        keyId: encriptedData?.keyId,
                        iv: encriptedData?.iv,
                        data: encriptedData?.encryptedData,
                    }
                    if (encriptedData?.keyId) {
                        const value = await eventChargeById(eventLinkId, payload);
                        commonRecaptchaToken.current = null;
                        if (value?.paymentSessionGid) {
                            setOrderData(value)
                            const orderData = await getWalletOrderInfo(value?.paymentSessionGid, value?.psClientSecret);
                            if (!orderData.id) {
                                const errorDetail = orderData.details[0];
                                const errorMessage = errorDetail
                                    ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                                    : "Unexpected error occurred, please try again.";

                                throw new Error(errorMessage);
                            }
                            return orderData?.id;
                        }
                    }
                }
            }
        } catch (error) {
            if (error?.status === 429) {
                setSavedPaymentDetails(paypalData);
                setRecaptchaPaymentType('payPalButton');
                setRecaptchaModalVisible(true);
                setTransactionModalOpen(false);
                throw new Error('Recatpcha Required');
            }
            console.error(error);
            throw error || new Error('Unexpected error occurred, please try again.');
        }
    };

    const googlePaySplitUp = {
        spObjectType: "SEATED_PAGE",
        spObjectGid: payment?.seatPageMeta?.gid,
        seatPageTicketEntries: selectedEntries,
        paymentType: "WALLET",
        subType: "GOOGLE_PAY_US",
        binType: "CREDIT"
    };

    const applePaySplitUp = {
        spObjectType: "SEATED_PAGE",
        spObjectGid: payment?.seatPageMeta?.gid,
        seatPageTicketEntries: selectedEntries,
        paymentType: "WALLET",
        subType: "APPLE_PAY_US",
        binType: "CREDIT"
    };

    const uniquePaymentTypes = paymentTypeOrder ? paymentTypeOrder.map((res) => res ? res.category : null) : supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';
    if (uniquePaymentTypes.includes('WALLET')) {
        if (swirepayUS) {
            uniquePaymentTypes.push('SWIREPAY_US');
        }
        if (!googlePayUs) {
            const index = uniquePaymentTypes.indexOf('WALLET');
            if (index > -1) {
                uniquePaymentTypes.splice(index, 1);  // Removes the 'WALLET' from the array
            }
        }
    }
    const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
        let children;
        let id;
        if (name === TabNames.ACH_LEGACY) {
            children = <AchPayment
                howCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={eventDetails && eventDetails?.name ? eventDetails : customerInfo}
                customerDisabled={false}
                headerText={null}
                showWhatsAppNotify={false}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={eventDetails && eventDetails.seatPageMetaTickets[0].currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                surcharge={surcharge}
                plaidPublicToken={plaidPublicToken}
                setPlaidPublicToken={setPlaidPublicToken}
                accountGid={payment?.account?.gid}
                paymentLinkId={eventLinkId}
                clearZipCode={true}
                isTest={payment?.account?.portal?.test}
                enableConsentCheckbox={true}
                prefix={payment?.currency?.prefix}
                accountName={payment?.account?.name}
                paymentDate={dayjs().format('MMMM D, YYYY')}
                finalPayAmount={amountInfo ? `${currencyFormatter((amountInfo && (amountInfo.totalPayable / 100.0)), eventDetails && eventDetails.seatPageMetaTickets[0].currency.name)}` : null}
            />
            id = name;
        } else if (name === TabNames.CARD) {
            children = <CardPayment
                errorMsg={errorMessage}
                errorHeader={null}
                hideCustomer={false}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={eventDetails && eventDetails?.name ? eventDetails : customerInfo}
                headerText={"Pay With Card"}
                buttonText={submitBtnText}
                customerValidation={true}
                alpha2={eventDetails && eventDetails.seatPageMetaTickets[0].currency.countryAlpha2}
                tax={amountInfo && amountInfo.tax}
                totalPayable={amountInfo && amountInfo.totalPayable}
                discount={amountInfo && amountInfo.discountedAmount}
                subTotal={amountInfo && amountInfo.subTotal}
                serviceFee={amountInfo && amountInfo.serviceFee}
                amount={amountInfo && amountInfo.net}
                serviceFeeRate={amountInfo && amountInfo.serviceFee}
                serviceFeeRateVal={amountInfo && amountInfo.serviceFee}
                serviceFeeVal={amountInfo && amountInfo.serviceFee}
                showMeta={!nonEventSeat}
                metaInfo={eventDetails && eventDetails}
                isZipCodeRequired={true}
                requiredPhone={true}
                showPromoter={(accountInfo && accountInfo.accountPromoter && accountInfo.accountPromoter.promoterName)}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                surcharge={surcharge}
                getCardNum={getCardNum}
                surchargeType={payment?.account?.surchargeType}
                updateSurcharge={updateSurcharge}
                surchargeEnabled={eventDetails?.surchargeEnabled}
                clearZipCode={true}
                payments={payment}
            />
            id = name;
        } else if (name === TabNames.UPI) {
            children = <UpiPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByUpi}
                preFillCustomer={eventDetails && eventDetails?.name ? eventDetails : customerInfo}
                headerText={"Pay With UPI"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                showMobileViewUpi={true}
                hideQr={false}
                showWhatsAppNotify={false}
                getPaymentById={null}
                supportedPaymentTypes={payment && payment.account && payment.account.supportedPaymentTypes}
                upiUrl={null}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkUpiGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkUpiGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
                acquirer={payment?.account?.acquirer}
            />
            id = name;
        } else if (name === TabNames.ACH) {
            children = <BankPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerDisabled={false}
                submit={chargeByBank}
                preFillCustomer={eventDetails && eventDetails?.name ? eventDetails : customerInfo}
                headerText={"Pay With Bank Transfer"}
                buttonText={submitBtnText}
                showWhatsAppNotify={false}
                eventLinkId={eventLinkId}
                iavUrl={null}
                customerValidation={true}
                cancelButtonText={"Decline"}
                requiredPhone={true}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                surcharge={surcharge}
            />
            id = name;
        } else if (name === TabNames.NET_BANKING) {
            children = <NetBanking
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByNetBanking}
                preFillCustomer={eventDetails && eventDetails?.name ? eventDetails : customerInfo}
                showWhatsAppNotify={false}
                headerText={"PAY WITH NET BANKING"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                banksList={banksList}
                bankTypes={bankTypes}
                isTest={isTest}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                surcharge={surcharge}
            />
            id = name;
        } else if (name === TabNames.GOOGLE_PAY_US) {
            children = <>
                {
                    payPalClientAuth ? (
                        <PayPalGooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            chargeByGooglePay={chargeByPaypalGooglePay}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                            accountGid={payment?.account?.gid}
                            setTransactionModalOpen={setTransactionModalOpen}

                            objectType="SEATED_PAGE"
                            objectGid={payment?.seatPageMeta?.gid}
                            totalAmount={amountInfo && amountInfo.totalPayable}
                            splitUpPayload={googlePaySplitUp}
                        />
                    ) : (
                        <GooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            chargeByGooglePay={chargeByGooglePay}
                            gpaySecretValues={gpaySecretValues}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                            splitUpPayload={googlePaySplitUp}
                        />
                    )
                }
            </>
            id = name;
        } else if (name === TabNames.WALLET) {
            children = <>
                {
                    payPalClientAuth ? (
                        <PayPalGooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            chargeByGooglePay={chargeByPaypalGooglePay}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                            accountGid={payment?.account?.gid}
                            setTransactionModalOpen={setTransactionModalOpen}

                            splitUpPayload={googlePaySplitUp}
                        />
                    ) : (
                        <GooglePay
                            headerText={"PAY WITH GOOGLE PAY"}
                            payment={payment}
                            chargeByGooglePay={chargeByGooglePay}
                            gpaySecretValues={gpaySecretValues}
                            gpayError={gpayError}
                            errorMsg={errorMessage}
                            errorHeader={null}
                            splitUpPayload={googlePaySplitUp}
                        />
                    )
                }
            </>
            id = name;
        } else if (name === TabNames.INSTANT_PAYMENT) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByInstantPay}
                preFillCustomer={eventDetails && eventDetails?.name ? eventDetails : customerInfo}
                customerDisabled={false}
                headerText={null}
                buttonText={submitBtnText}
                hideQr={false}
                getPaymentById={null}
                showWhatsAppNotify={false}
                upiUrl={null}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                surcharge={surcharge}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkInstantPaymentGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkInstantPaymentGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
            />
            id = name;
        } else if (name === TabNames.SWIREPAY_US) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeBySwirepayUS}
                preFillCustomer={eventDetails && eventDetails?.name ? eventDetails : customerInfo}
                customerDisabled={false}
                headerText={null}
                buttonText={submitBtnText}
                hideQr={false}
                getPaymentById={getQrPaymentById}
                showWhatsAppNotify={false}
                paymentMethodDetails={true}
                paymentMethodType={true}
                upiUrl={`${BASE_URLS.SEATS_PAGE}/${eventLinkId}`}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                swirepayUS={swirepayUS}
                seatPagePay={true}
                metaGid={eventDetails.gid}
                metaPageEntries={selectedEntries}
                tip={finalTip}
                surcharge={surcharge}
                setRecaptchaModalVisible={setRecaptchaModalVisible}
                setSavedPaymentDetails={setSavedPaymentDetails}
                savedPaymentDetails={savedPaymentDetails}
                globalRecaptchaToken={paymentLinkInstantPaymentGlobalRecaptcha}
                setGlobalRecaptchaToken={setPaymentLinkInstantPaymentGlobalRecaptcha}
                setRecaptchaPaymentType={setRecaptchaPaymentType}
            />
            id = name;
        } else {
            children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
        }
        panel.push({ children, id });
        return panel;
    }, []) : [
        {
            children: <CardPayment
                errorMsg={errorMessage}
                errorHeader={null}
                hideCustomer={false}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={eventDetails && eventDetails?.name ? eventDetails : customerInfo}
                headerText={"Pay With Card"}
                buttonText={submitBtnText}
                customerValidation={true}
                alpha2={eventDetails && eventDetails.seatPageMetaTickets[0].currency.countryAlpha2}
                tax={amountInfo && amountInfo.tax}
                totalPayable={amountInfo && amountInfo.totalPayable}
                discount={amountInfo && amountInfo.discountedAmoun}
                subTotal={amountInfo && amountInfo.subTotal}
                serviceFee={amountInfo && amountInfo.serviceFee}
                amount={amountInfo && amountInfo.net}
                serviceFeeRate={amountInfo && amountInfo.serviceFee}
                serviceFeeRateVal={amountInfo && amountInfo.serviceFee}
                serviceFeeVal={amountInfo && amountInfo.serviceFee}
                showMeta={!nonEventSeat}
                metaInfo={eventDetails && eventDetails}
                isZipCodeRequired={true}
                showPromoter={(accountInfo && accountInfo.accountPromoter && accountInfo.accountPromoter.promoterName)}
                requiredPhone={true}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                surcharge={surcharge}
                getCardNum={getCardNum}
                surchargeType={payment?.account?.surchargeType}
                updateSurcharge={updateSurcharge}
                surchargeEnabled={eventDetails?.surchargeEnabled}
                clearZipCode={true}
                payments={payment}
            />,
            id: 'CARD'
        }
    ];


    let abc = AmountDivideByHundred(amountInfo && amountInfo.net);


    const tabPanelsApple =
    {
        // children :  <Apple amount={AmountDivideByHundred(amountInfo && amountInfo.net)} chargeByApple={chargeByApple} payment={payment}/>
        children: <>
            {
                payPalClientAuth ? (
                    <ApplePayButton
                        recaptchaToken={paypalApplePayRecaptcha}
                        amount={amountInfo && amountInfo.totalPayable}
                        chargeByApple={chargeByApple}
                        payment={payment}
                        accountGid={payment?.account?.gid}
                        successCallback={chargeByIdSuccessActions}
                        failCallback={chargeByIdFailActions}
                        splitUpPayload={applePaySplitUp}
                    />
                ) : (
                    <>
                        {
                            applePayment && isApplePay ? <Apple amount={amountInfo && amountInfo.totalPayable} chargeByApple={chargeByCardpointeApplePay} payment={payment} splitUpPayload={applePaySplitUp} /> : null
                        }
                    </>
                )
            }
            </>,
        id: applePayment && isApplePay ? 'APPLE_PAY_US' : null
    };

    tabPanels.push(tabPanelsApple);

    if (payment?.account?.country?.alpha2 === 'US') {
      tabPanels.push({
        children: <SavedPaymentMethods
                    buttonText={submitBtnText}
                    submit={chargeBySavedPaymentMethods}
                    supportedPaymentTypes={uniquePaymentTypes}
                    surchargeEnabled={eventDetails?.surchargeEnabled}
                    surchargeType={payment?.account?.surchargeType}
                    updateSurcharge={updateSurcharge}
                    surcharge={surcharge}
                    serviceFee={amountInfo?.serviceFee}
                    serviceFeeRate={amountInfo?.serviceFee}
                    serviceFeeRateVal={amountInfo?.serviceFee}
                    amount={amountInfo?.net}
                    serviceFeeVal={amountInfo?.serviceFee}
                    discount={amountInfo?.discountedAmount}
                    subTotal={amountInfo?.subTotal}
                    totalPayable={amountInfo?.totalPayable}
                    prefix={payment?.currency?.prefix}
                    tax={amountInfo?.tax}
                    accountSupportedPaymentTypes={payment?.account?.supportedPaymentTypes}
                  />,
        id: 'SAVED_PAYMENT_METHODS'
      });
    }

    if (payPalClientAuth && payPalClientId && (payment?.account?.supportedPaymentTypes?.includes('PAYPAL_WALLET') || payment?.account?.supportedPaymentTypes?.includes('VENMO'))) {
      tabPanels.push({
        children: <div style={{ width: '200px'}} >
        <PayPalCheckout
            styles={{ shape: "rect", layout: "vertical" }}
            createOrder={createOrder}
            onApprove={onApprove}
            payPalClientId={payPalClientId}
            currency={payment?.account?.currency?.name || 'USD'}
            country={payment?.account?.country?.alpha2 || 'US'}
            accountSupportedPaymentTypes={payment?.account?.supportedPaymentTypes}
        />
        </div>,
        id: 'PAYPAL_METHOD',
      });
      uniquePaymentTypes.push('PAYPAL_METHOD');
    }

    useEffect(() => {
        setTabName(uniquePaymentTypes && uniquePaymentTypes[selectedTab]);
    }, [selectedTab, uniquePaymentTypes]);
    const agregatorName = payment && payment.account && payment.account.aggregatorName;
    return (
        <BaseSplitPage
        errorHeader={null}
        errorMsg={errorMessage}
        left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        {
                            (payment && payment.account && payment.account.largeLogo) && (
                                <img src={payment.account.largeLogo} style={{ width: "125px" }} alt="" />
                            )
                        }
                        <H1Text>
                            Payment Checkout
                        </H1Text>
                        <H2Text>
                            Payment For {payment && payment.account && <DescriptionText>{payment.account.name}</DescriptionText>}
                        </H2Text>
                        {
                            selectedSeats && selectedSeats.length !== 0 && (
                                <>
                                    {
                                        selectedSeats.map((item) => (
                                            item.numSelected ?
                                                <DescriptionText>{item.seatId} - {item.numSelected}</DescriptionText>
                                                : <DescriptionText>{item.seatId}</DescriptionText>
                                        ))
                                    }
                                </>
                            )
                        }
                        <H2Text>
                            Amount Payable
                        </H2Text>
                        <DescriptionText fontSize="24px">
                            {amountInfo ? `${currencyFormatter((amountInfo && (amountInfo.totalPayable / 100.0)), eventDetails && eventDetails.seatPageMetaTickets[0].currency.name)}` : null}
                        </DescriptionText>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={payment && payment.support && payment.support.email}
                            phone={payment && payment.support && payment.support.phone}
                            partnerImageUrl={partnerImageUrl}
                            bankImageUrl={bankImageUrl}
                            whiteLabel={payment && payment.account && payment.account.whiteLabel}
                        />
                        {agregatorName === 'EPAYMENTS' ?
                            <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }} >
                                <a href="https://www.swirepay.com" target="_blank" >
                                    <img src={EPaymentImg} alt="" />
                                </a>
                            </div>
                            :
                            agregatorName === 'OMEGAITR' ?
                                <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }} >
                                    <a href="https://www.swirepay.com" target="_blank" >
                                        <img src={OMEGAITRlogo} alt="" />
                                    </a>
                                </div>
                                :
                                ''
                        }
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header
                    account={payment ? payment.account : null}
                    payment={amountInfo}
                    eventDetails={eventDetails}
                    selectedSeats={selectedSeats}
                    bankImageUrl={bankImageUrl}
                    cancelUrlLink={`/seat-page-link/${eventLinkId}`}
                />
                {payment?.account?.country?.alpha2 === 'US' ? (
                  <PaymentExpandableRowsV2
                    id={eventLinkId}
                    paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                    tabs={uniquePaymentTypes}
                    tabPanels={tabPanels}
                    defaultSelectedTab={selectedTab || 0}
                    onSelect={data => setSelectedTab(data)}
                    tabName={tabName}
                    upiDown={upiDownTime}
                    applePayment={applePayment}
                    isApplePay={isApplePay}
                    accountGid={payment?.account?.gid}
                    getCurrentTab={getCurrentTab}
                    supportedPaymentTypes={payment?.account?.supportedPaymentTypes}
                    account={payment?.account}
                  />) : (
                  <PaymentExpandableRows
                    id={eventLinkId}
                    paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                    tabs={uniquePaymentTypes}
                    tabPanels={tabPanels}
                    defaultSelectedTab={selectedTab || 0}
                    onSelect={data => setSelectedTab(data)}
                    tabName={tabName}
                    upiDown={upiDownTime}
                    applePayment={applePayment}
                    isApplePay={isApplePay}
                    accountGid={payment?.account?.gid}
                    getCurrentTab={getCurrentTab}
                  />
                )}
                <SmallScreenFooter
                    partnerImageUrl={partnerImageUrl}
                    bankImageUrl={bankImageUrl}
                    whiteLabel={payment && payment.account && payment.account.whiteLabel}
                />
                {
                    payPalClientAuth && payPalClientId ? (
                        <>
                            <DescriptionText className="mb-3" fontSize="17px">PAY WITH PAYPAL</DescriptionText>
                            <PayPalCheckout
                                styles={{ shape: "rect", layout: "vertical" }}
                                createOrder={createOrder}
                                onApprove={onApprove}
                                payPalClientId={payPalClientId}
                                currency={payment?.account?.currency?.name || 'USD'}
                                country={payment?.account?.country?.alpha2 || 'US'}
                            />
                        </>
                    ) : (
                        <></>
                    )
                }
                <RecaptchaModal
                    visible={recaptchaModalVisible}
                    onVerified={onGlobalCaptchaVerified}
                />
                <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
                <SuccessModal isOpen={isTransactionSuccessModalOpen} processing={processStatus} manualPlaidPayment={manualPlaidPayment} />
                <AlertModal
                    showIcon={alertConfig.showIcon}
                    isOpen={alertConfig.isOpen}
                    hideBtn={alertConfig.hideBtn}
                    cancel={alertConfig.cancel}
                    header={alertConfig.header}
                    body={alertConfig.body}
                    submitBtnText={alertConfig.submitBtnText}
                    cancelBtnText={alertConfig.cancelBtnText}
                    showCancelBtn={alertConfig.showCancelBtn}
                    showSubmitBtn={alertConfig.showSubmitBtn} submit={alertConfig.submit} icon={alertConfig.icon} />
                <Spinner isOpen={isShowSpinner} />
            </>
        } />
    )
};

export default SeatsPay;
